module.exports = __webpack_public_path__ + "img/frame07_stamp.36162463.png";